
export class MensajePisoModel {

  nombre: string;
  email: string;
  mensaje: string;
  destinatario: string;

}
